/* Snackstalgia theme v2 — small, dependency-free behaviours.
   Everything degrades gracefully: with JS off, content is visible and
   forms submit normally. */
(function () {
  'use strict';

  document.documentElement.classList.add('js');

  var qs = function (sel, root) { return (root || document).querySelector(sel); };
  var qsa = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Mobile navigation ---------- */
  var toggle = qs('[data-nav-toggle]');
  var nav = qs('[data-site-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Scroll reveal ---------- */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var reveals = qsa('.reveal');
  if (reveals.length) {
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    }
  }

  /* ---------- Cart count ---------- */
  function setCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  }
  function refreshCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCartCount(cart.item_count); return cart; });
  }

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var wrap = btn.closest('[data-qty]');
    var input = wrap && qs('input', wrap);
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-step'), 10) || 0;
    var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Add to cart (AJAX, opens the mini-cart) ---------- */
  qsa('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var buttons = qsa('[data-add-btn]', form).concat(qsa('[data-sticky-add]'));
      var errorBox = qs('[data-form-error]', form);
      if (errorBox) errorBox.textContent = '';
      buttons.forEach(function (b) { b.disabled = true; b._html = b.innerHTML; b.textContent = form.getAttribute('data-adding') || 'Adding...'; });
      function restore() {
        buttons.forEach(function (b) { b.disabled = false; if (b._html != null) b.innerHTML = b._html; });
      }

      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data && res.data.description ? res.data.description : 'Could not add to cart');
          return refreshCartCount();
        })
        .then(function () {
          if (window.SnackCart && window.SnackCart.openAfterAdd) {
            restore();
            return window.SnackCart.openAfterAdd();
          }
          window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart';
        })
        .catch(function (err) {
          restore();
          if (errorBox) errorBox.textContent = err.message;
        });
    });
  });

  /* ---------- Variant picker (product page) ---------- */
  var productJson = qs('[data-product-json]');
  var pdpForm = qs('form[data-product-form][data-has-options="true"]');
  if (productJson && pdpForm) {
    var product = JSON.parse(productJson.textContent);
    var idInput = qs('[name="id"]', pdpForm);
    var priceEl = qs('[data-price]');
    var stickyPrice = qs('[data-sticky-price]');
    var addBtns = qsa('[data-add-btn]', pdpForm).concat(qsa('[data-sticky-add]'));
    var mainImg = qs('[data-main-img]');
    var soldOut = pdpForm.getAttribute('data-sold-out') || 'Sold out';
    var addLabel = pdpForm.getAttribute('data-add-label') || 'Add to cart';
    var moneyFmt = function (cents) {
      var v = (cents / 100);
      var s = (v % 1 === 0) ? v.toFixed(0) : v.toFixed(2);
      return (pdpForm.getAttribute('data-currency') || 'AED') + ' ' + s;
    };

    var currentVariant = function () {
      var picked = [];
      qsa('[data-option-group]', pdpForm).forEach(function (group, i) {
        var checked = qs('input:checked', group);
        picked[i] = checked ? checked.value : null;
      });
      return product.variants.filter(function (v) {
        return picked.every(function (val, i) { return val === null || v.options[i] === val; });
      })[0];
    };

    var update = function () {
      var variant = currentVariant();
      if (!variant) {
        addBtns.forEach(function (b) { b.disabled = true; b.textContent = soldOut; });
        return;
      }
      idInput.value = variant.id;
      if (priceEl) {
        priceEl.innerHTML = moneyFmt(variant.price) + (variant.compare_at_price && variant.compare_at_price > variant.price ? ' <s>' + moneyFmt(variant.compare_at_price) + '</s>' : '');
      }
      if (stickyPrice) stickyPrice.textContent = moneyFmt(variant.price);
      addBtns.forEach(function (b) {
        b.disabled = !variant.available;
        b.textContent = variant.available ? addLabel : soldOut;
      });
      if (variant.featured_image && mainImg) {
        var src = variant.featured_image.src;
        mainImg.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1200';
        mainImg.removeAttribute('srcset');
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    };

    pdpForm.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-group]')) update();
    });
  }

  /* ---------- Gallery thumbs ---------- */
  qsa('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = qs('[data-main-img]');
      if (!main) return;
      main.src = thumb.getAttribute('data-large');
      main.removeAttribute('srcset');
      main.alt = thumb.getAttribute('data-alt') || '';
      qsa('[data-thumb]').forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
    });
  });

  /* ---------- Sticky add-to-cart (mobile) ---------- */
  var sticky = qs('[data-sticky-atc]');
  var mainAdd = qs('form[data-product-form] [data-add-btn]');
  if (sticky && mainAdd && 'IntersectionObserver' in window) {
    var stickyIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var pastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', pastButton);
      });
    });
    stickyIo.observe(mainAdd);
  }
  var stickyBtn = qs('[data-sticky-add]');
  if (stickyBtn && mainAdd) {
    stickyBtn.addEventListener('click', function () {
      var form = mainAdd.closest('form');
      if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
    });
  }
})();